module.exports = __webpack_public_path__ + "img/snapshot-default.beaebc6c.png";